<template>
  <div class="header-ios-safe">
    <header class="bg-white text-primary">
      <QToolbar>
        <QBtn round color="primary" icon="icon-f-arrow-left" dense flat @click="onClickBack" />
        <QToolbarTitle>
          {{ t("CORE.DOCUMENTS.@MY_DOCUMENTS") }}
        </QToolbarTitle>
      </QToolbar>
    </header>
    <div>
      <div class="row full-height q-mt-lg">
        <div class="col" />
        <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-xs-11 q-px-sm">
          <div class="candidate-documents-menu">
            <section class="candidate-documents-menu-list">
              <ExAnimatedMenu background="white" :items="menuItems" :active-item="activeMenuItem" @action="updateMenu" />
            </section>
          </div>
          <KeepAlive>
            <component :is="componentToDisplay" :ref="componentSlug" />
          </KeepAlive>
        </div>
        <div class="col" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { useI18n } from "vue-i18n";
  import { ExAnimatedMenu } from "@extracadabra/ui-kit";
  import { DocumentType, DocumentEvent } from "@extracadabra/core-v2";
  import { ETAB_ROUTES } from "@etab/config";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { PosthogManager } from "@core/managers/posthog.manager";
  import { DOCUMENTS_MANAGER_POSTHOG_EVENTS } from "@core/constants/common";

  import InvoicesPage from "./Invoices.page.vue";
  import ServiceContractPage from "./ServiceContract.page.vue";

  const MAIN_MENU = "menu";

  const router = useRouter();
  const route = useRoute();
  const { t } = useI18n();

  const activeMenuItem = ref(null);

  const menuItems = computed(() => [
    {
      icon: "money-bill-transfer",
      label: t("CORE.DOCUMENTS.MENU.@INVOICES"),
      action: {
        type: "component",
        target: DocumentType.Invoice,
      },
    },
    {
      icon: "file-contract",
      label: t("CORE.DOCUMENTS.MENU.@AGREEMENT_CONTRACT"),
      action: {
        type: "component",
        target: DocumentType.ServiceContract,
      },
    },
  ]);

  const componentSlug = computed(() => {
    return route.params.documentSlug;
  });

  const componentToDisplay = computed(() => {
    switch (componentSlug.value) {
      case DocumentType.Invoice:
        return InvoicesPage;
      case DocumentType.ServiceContract:
        return ServiceContractPage;
      default:
        return null;
    }
  });

  watch(componentSlug, (newValue, oldValue) => {
    if (newValue === MAIN_MENU && activeMenuItem.value !== null) {
      activeMenuItem.value = null;
    }
  });

  const updateMenu = async (item) => {
    activeMenuItem.value = item;
    const targetPage = item?.action.target;
    router.push({
      name: ETAB_ROUTES.account.documents.slug.name,
      params: { documentSlug: targetPage || MAIN_MENU },
    });

    if (targetPage) {
      TrackingManager.addEvent({
        event: DocumentEvent.VIEW_SECTION,
        params: targetPage,
      });
      PosthogManager.captureEvent(DOCUMENTS_MANAGER_POSTHOG_EVENTS, {
        name: DocumentEvent.VIEW_SECTION,
        type: targetPage,
      });
    }
  };

  const onClickBack = () => {
    router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch((suppressedError) => {});
  };

  onMounted(async () => {
    if (componentSlug.value !== MAIN_MENU) {
      activeMenuItem.value = menuItems.value.find((item) => item.action.target === componentSlug.value) || null;
    }
  });
</script>
